<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  @if (authenticationOptions() !== null) {
    <orbit-form-field
      [inputType]="'email'"
      [label]="'SHARED.LOGIN.EMAIL_LABEL' | translate"
      [name]="'email'"
      [testId]="'input-login-disabled-email'"
      [disabled]="true"
      [controller]="email" />
    <orbit-form-field
      [autocomplete]="false"
      [inputType]="'password'"
      [label]="'SHARED.LOGIN.PASSWORD_LABEL' | translate"
      [name]="'password'"
      [testId]="'input-login-password'"
      [controller]="password" />
    <orbit-button
      [label]="'SHARED.LOGIN.BUTTON_LABEL' | translate"
      [inputId]="'login-button'"
      [testId]="'btn-login-submit'"
      type="submit"
      class="w-full"
      styleClass="w-full"
      size="large" />
    @for (authOption of authenticationOptions()?.oidcProviders; track $index) {
      <orbit-button
        [label]="'SHARED.LOGIN.WITH_PROVIDER' | translate: { provider: authOption.providerName }"
        [inputId]="'login-with-' + authOption.providerName"
        [testId]="'btn-login-with-' + authOption.providerName"
        (buttonClick)="signInWithOidcProvider(authOption.authorityUrl)"
        class="w-full"
        styleClass="w-full"
        size="large" />
    }
    <orbit-button
      [label]="'SHARED.LOGIN.FORGOT_PASSWORD' | translate"
      [inputId]="'forgot-password'"
      [testId]="'btn-forgot-password'"
      [flat]="true"
      [type]="'button'"
      (buttonClick)="forgotPassword()" />

    <orbit-button
      [label]="'SHARED.LOGIN.BACK' | translate"
      [inputId]="'back'"
      [testId]="'btn-back-to-email'"
      (buttonClick)="backToEmail()"
      [flat]="true" />
  } @else {
    <orbit-form-field
      [inputType]="'email'"
      [label]="'SHARED.LOGIN.EMAIL_LABEL' | translate"
      [name]="'email'"
      [testId]="'input-login-email'"
      [controller]="email" />

    <orbit-button
      [label]="'SHARED.LOGIN.BUTTON_LABEL' | translate"
      [inputId]="'login-button'"
      [testId]="'btn-login-proceed'"
      [disabled]="!formIsValid()"
      type="button"
      class="w-full"
      styleClass="w-full"
      size="large"
      (buttonClick)="onProceed()" />
  }
</form>
